import * as React from "react";
import { JSX } from "react/jsx-runtime";
const CalenderRightIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={29}
    height={24}
    viewBox="0 0 29 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.76328 21.4891C7.53828 21.4891 7.35078 21.4141 7.16328 21.2641C6.82578 20.9266 6.82578 20.4016 7.16328 20.0641L15.0383 12.0016L7.16328 3.97656C6.82578 3.63906 6.82578 3.11406 7.16328 2.77656C7.50078 2.43906 8.02578 2.43906 8.36328 2.77656L16.8383 11.4016C17.1758 11.7391 17.1758 12.2641 16.8383 12.6016L8.36328 21.2266C8.21328 21.3766 7.98828 21.4891 7.76328 21.4891Z"
      fill="#004E9B"
    />
    <path
      d="M12.7633 21.4891C12.5383 21.4891 12.3508 21.4141 12.1633 21.2641C11.8258 20.9266 11.8258 20.4016 12.1633 20.0641L20.0383 12.0016L12.1633 3.97656C11.8258 3.63906 11.8258 3.11406 12.1633 2.77656C12.5008 2.43906 13.0258 2.43906 13.3633 2.77656L21.8383 11.4016C22.1758 11.7391 22.1758 12.2641 21.8383 12.6016L13.3633 21.2266C13.2133 21.3766 12.9883 21.4891 12.7633 21.4891Z"
      fill="#004E9B"
    />
  </svg>
);
export default CalenderRightIcon;
